import React from 'react'
import Button from 'components/formElements/Button'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { Link } from 'react-router-dom'
import DefaultSelect from 'components/formElements/DefaultSelect'

const CreateProject = () => {
	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			<div className='card'>
				<div className='row'>
					<div className='col-md-12'>
						<div className='heading-2'>Proje Oluştur</div>
					</div>
				</div>
				<div className='w-100 d-flex flex-column gap-3'>
					<div className='row'>
						<div className='col-md-12'>
							<input className='default-input' type='text' placeholder='Proje Başlığı' />
						</div>
					</div>
					<div className='row'>
						<div className='col-md-12'>
							<DefaultSelect
								isMulti
								placeholder='Proje Tipi'
								selectOptions={[
									{ label: 'Ongoing', value: '1' },
									{ label: 'SLA', value: '2' },
									{ label: 'CR', value: '3' },
								]}
							/>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-12 d-flex justify-content-end gap-3'>
							<Link to={-1} className='btn-danger-outline'>
								Vazgeç
							</Link>
							<Button className='btn-success' title='Kaydet' />
						</div>
					</div>
				</div>
			</div>
		</AnimatedSpan>
	)
}

export default CreateProject
